import checkModule from "../../utils/checkModule";
import { useAppSelector } from "../hooks";
import { createAppSelector } from "./util";

export const selectModules = createAppSelector(
  [(state) => state.user.modules, (state) => state.overrideModules[state.user.organization_id]],
  (userModules = [], overrideModules = []) => {
    return [...userModules.filter((m) => !overrideModules.find((o) => o.name === m.name)), ...overrideModules];
  },
);

export const useModuleEnabled = (moduleName: string) => {
  const modules = useAppSelector(selectModules);
  return checkModule(modules, moduleName);
};

export const useEnabledModules = () => {
  return useAppSelector(selectModules);
};
